import Axios from 'axios';
import {
    ADD_DESTINATION_SET,
    ADD_LIVE_STREAM_DESTINATION_ERROR,
    ADD_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    ADD_LIVE_STREAM_DESTINATION_SUCCESS,
    ADD_STREAM_ENABLE_SET,
    ADD_STREAM_KEY_SET,
    ADD_STREAM_URL_SET,
    ADD_STREAM_USER_NAME_SET,
    DELETE_DESTINATION_DIALOG_HIDE,
    DELETE_DESTINATION_DIALOG_SHOW,
    DELETE_LIVE_STREAM_DESTINATION_ERROR,
    DELETE_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    DELETE_LIVE_STREAM_DESTINATION_SUCCESS,
    FETCH_LIVE_STREAM_DESTINATION_ERROR,
    FETCH_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    FETCH_LIVE_STREAM_DESTINATION_SUCCESS,
    INPUT_STREAM_KEY_SET,
    INPUT_STREAM_URL_SET,
    LIVE_STREAM_DEFAULT_FILE_ADD_CANCEL_SET,
    LIVE_STREAM_DEFAULT_FILE_ADD_ERROR,
    LIVE_STREAM_DEFAULT_FILE_ADD_IN_PROGRESS,
    LIVE_STREAM_DEFAULT_FILE_ADD_PROGRESS_SET,
    LIVE_STREAM_DEFAULT_FILE_ADD_SUCCESS,
    LIVE_STREAM_DEFAULT_FILE_FETCH_ERROR,
    LIVE_STREAM_DEFAULT_FILE_FETCH_IN_PROGRESS,
    LIVE_STREAM_DEFAULT_FILE_FETCH_SUCCESS,
    LIVE_STREAM_DEFAULT_FILE_SET,
    LIVE_STREAM_DESTINATION_UPDATE_ERROR,
    LIVE_STREAM_DESTINATION_UPDATE_IN_PROGRESS,
    LIVE_STREAM_DESTINATION_UPDATE_SUCCESS,
    LIVE_STREAM_TAB_SET,
    LIVE_STREAM_TEXT_ADD_ERROR,
    LIVE_STREAM_TEXT_ADD_IN_PROGRESS,
    LIVE_STREAM_TEXT_ADD_SUCCESS,
    LIVE_STREAM_TEXT_ENABLE_SET,
    LIVE_STREAM_TEXT_SET,
    LIVE_STREAMS_DETAILS_FETCH_ERROR,
    LIVE_STREAMS_DETAILS_FETCH_IN_PROGRESS,
    LIVE_STREAMS_DETAILS_FETCH_SUCCESS,
    LIVE_STREAMS_DETAILS_SET,
    LIVE_STREAMS_FETCH_ERROR,
    LIVE_STREAMS_FETCH_IN_PROGRESS,
    LIVE_STREAMS_FETCH_SUCCESS,
    LIVE_STREAMS_STATUS_FETCH_ERROR,
    LIVE_STREAMS_STATUS_FETCH_IN_PROGRESS,
    LIVE_STREAMS_STATUS_FETCH_SUCCESS,
    LIVE_STREAMS_WATCH_URL_FETCH_ERROR,
    LIVE_STREAMS_WATCH_URL_FETCH_IN_PROGRESS,
    LIVE_STREAMS_WATCH_URL_FETCH_SUCCESS,
    OUTPUT_DESTINATION_DIALOG_HIDE,
    OUTPUT_DESTINATION_DIALOG_SHOW,
    OUTPUT_DESTINATION_SET,
    OUTPUT_DESTINATIONS_LIST_SET,
    STREAM_START_ERROR,
    STREAM_START_IN_PROGRESS,
    STREAM_START_SUCCESS,
    STREAM_STOP_ERROR,
    STREAM_STOP_IN_PROGRESS,
    STREAM_STOP_SUCCESS,
    UPDATE_STREAM_DETAILS_IN_PROGRESS,
    UPDATE_STREAM_DETAILS_SUCCESS,
    UPDATE_STREAM_DETAILS_ERROR,
    FETCH_COMBINED_CHANNELS_IN_PROGRESS,
    FETCH_COMBINED_CHANNELS_SUCCESS,
    FETCH_COMBINED_CHANNELS_ERROR,
    STREAM_PATH_ERROR,
    STREAM_PATH_IN_PROGRESS,
    STREAM_PATH_SUCCESS,
    MEDIA_NODE_LIVE_STREAMS_FETCH_IN_PROGRESS,
    MEDIA_NODE_LIVE_STREAMS_FETCH_SUCCESS,
    MEDIA_NODE_LIVE_STREAMS_FETCH_ERROR,
    MEDIA_NODE_SELECTION_DIALOG_HIDE,
    MEDIA_NODE_SELECTION_DIALOG_SHOW,
    CONNECT_LIVE_STREAM_TO_MEDIA_NODE_ERROR,
    CONNECT_LIVE_STREAM_TO_MEDIA_NODE_IN_PROGRESS,
    CONNECT_LIVE_STREAM_TO_MEDIA_NODE_SUCCESS,
    BROADCAST_STREAM_ELIGIBILITY_CHECK_IN_PROGRESS,
    BROADCAST_STREAM_ELIGIBILITY_CHECK_SUCCESS,
    BROADCAST_STREAM_ELIGIBILITY_CHECK_ERROR,
} from '../../constants/mediaNodes/liveStream';
import {
    urlAddLSDestination,
    urladdStreamDefaultFile,
    urladdStreamText,
    urlFetchLiveStreamDetails,
    urlFetchLiveStreams,
    urlFetchLiveStreamStatus,
    urlFetchLiveStreamWatchUrl,
    urlgetStreamDefaultFile,
    urlstreamStart,
    urlstreamStop,
    urlstreamPath,
    urlupdateLiveStreamDestination,
    urlUpdateLSDestination,
    urlFetchMediaNodeLiveStreams,
    urlConnectLiveStreamToMediaNode,
    urlstreamStopLiveFeed,
    urlCheckBroadcastStreamEligibility,
} from '../../constants/mediaNodes/url';
import { handleErrorMessage } from '../../utils/errorMessages';
import { getAssetType } from '../../utils/strings';
import { urlFetchCombinedChannels, urlUpdateLiveStreamMetaData } from '../../constants/url';

export const setInputStreamUrl = (value) => {
    return {
        type: INPUT_STREAM_URL_SET,
        value,
    };
};

export const setInputStreamKey = (value) => {
    return {
        type: INPUT_STREAM_KEY_SET,
        value,
    };
};

export const setOutputDestinationsList = (value) => {
    return {
        type: OUTPUT_DESTINATIONS_LIST_SET,
        value,
    };
};

export const setOutputDestination = (value) => {
    return {
        type: OUTPUT_DESTINATION_SET,
        value,
    };
};

export const setAddDestination = (value) => {
    return {
        type: ADD_DESTINATION_SET,
        value,
    };
};

export const setAddStreamUrl = (value) => {
    return {
        type: ADD_STREAM_URL_SET,
        value,
    };
};

export const setAddStreamKey = (value) => {
    return {
        type: ADD_STREAM_KEY_SET,
        value,
    };
};

export const setAddStreamEnable = (value) => {
    return {
        type: ADD_STREAM_ENABLE_SET,
        value,
    };
};

export const setAddStreamUserName = (value) => {
    return {
        type: ADD_STREAM_USER_NAME_SET,
        value,
    };
};

export const showOutputDestinationDialog = (from, value) => {
    return {
        type: OUTPUT_DESTINATION_DIALOG_SHOW,
        value,
        from,
    };
};

export const hideOutputDestinationDialog = () => {
    return {
        type: OUTPUT_DESTINATION_DIALOG_HIDE,
    };
};

export const showDeleteDestinationDialog = (value) => {
    return {
        type: DELETE_DESTINATION_DIALOG_SHOW,
        value,
    };
};

export const hideDeleteDestinationDialog = () => {
    return {
        type: DELETE_DESTINATION_DIALOG_HIDE,
    };
};

export const setLiveStreamTabValue = (value) => {
    return {
        type: LIVE_STREAM_TAB_SET,
        value,
    };
};

const fetchLiveStreamsInProgress = () => {
    return {
        type: LIVE_STREAMS_FETCH_IN_PROGRESS,
    };
};

const fetchLiveStreamsSuccess = (value) => {
    return {
        type: LIVE_STREAMS_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamsError = (message) => {
    return {
        type: LIVE_STREAMS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchLiveStreams = (cb) => (dispatch) => {
    dispatch(fetchLiveStreamsInProgress());

    const URL = urlFetchLiveStreams();
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchLiveStreamsSuccess(res.data && res.data.result && res.data.result.list));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamsError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

const fetchLiveStreamDetailsInProgress = () => {
    return {
        type: LIVE_STREAMS_DETAILS_FETCH_IN_PROGRESS,
    };
};

const fetchLiveStreamDetailsSuccess = (value) => {
    return {
        type: LIVE_STREAMS_DETAILS_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamDetailsError = (message, url, nodeID) => {
    return {
        type: LIVE_STREAMS_DETAILS_FETCH_ERROR,
        message,
        url,
        nodeID,
        variant: 'error',
    };
};

export const setLiveStreamDetails = (value) => {
    return {
        type: LIVE_STREAMS_DETAILS_SET,
        value,
    };
};

export const fetchLiveStreamDetails = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(fetchLiveStreamDetailsInProgress());

    const URL = urlFetchLiveStreamDetails(url, id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchLiveStreamDetailsSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamDetailsError(message, url, nodeID));
            if (cb) {
                cb(null);
            }
        });
};

const fetchLiveStreamStatusInProgress = (reset) => {
    return {
        type: LIVE_STREAMS_STATUS_FETCH_IN_PROGRESS,
        reset,
    };
};

export const fetchLiveStreamStatusSuccess = (value) => {
    return {
        type: LIVE_STREAMS_STATUS_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamStatusError = (message, url, nodeID) => {
    return {
        type: LIVE_STREAMS_STATUS_FETCH_ERROR,
        message,
        url,
        nodeID,
        variant: 'error',
    };
};

export const fetchLiveStreamStatus = (url, id, nodeID, reset, cb) => (dispatch) => {
    dispatch(fetchLiveStreamStatusInProgress(reset));

    const URL = urlFetchLiveStreamStatus(url, id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchLiveStreamStatusSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamStatusError(message, url, nodeID));
            if (cb) {
                cb(null);
            }
        });
};

const fetchLiveStreamWatchUrlInProgress = () => {
    return {
        type: LIVE_STREAMS_WATCH_URL_FETCH_IN_PROGRESS,
    };
};

const fetchLiveStreamWatchUrlSuccess = (value) => {
    return {
        type: LIVE_STREAMS_WATCH_URL_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamWatchUrlError = (message) => {
    return {
        type: LIVE_STREAMS_WATCH_URL_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchLiveStreamWatchUrl = (url, id, nodeID) => (dispatch) => {
    dispatch(fetchLiveStreamWatchUrlInProgress());

    const URL = urlFetchLiveStreamWatchUrl(url, id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchLiveStreamWatchUrlSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamWatchUrlError(message));
        });
};

const streamStartInProgress = () => {
    return {
        type: STREAM_START_IN_PROGRESS,
    };
};

const streamStartSuccess = (value) => {
    return {
        type: STREAM_START_SUCCESS,
        value,
    };
};

const streamStartError = (message) => {
    return {
        type: STREAM_START_ERROR,
        message,
        variant: 'error',
    };
};

export const streamStart = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(streamStartInProgress());

    const URL = urlstreamStart(url, id);
    Axios.post(URL, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(streamStartSuccess(res.data && res.data.success));
            if (cb) {
                cb(res.data && res.data.success);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(streamStartError(message));
            if (cb) {
                cb(null);
            }
        });
};

const streamStopInProgress = () => {
    return {
        type: STREAM_STOP_IN_PROGRESS,
    };
};

const streamStopSuccess = (value) => {
    return {
        type: STREAM_STOP_SUCCESS,
        value,
    };
};

const streamStopError = (message) => {
    return {
        type: STREAM_STOP_ERROR,
        message,
        variant: 'error',
    };
};

export const streamStop = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(streamStopInProgress());

    const URL = urlstreamStop(url, id);
    Axios.post(URL, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(streamStopSuccess(res.data && res.data.success));
            if (cb) {
                cb(res.data && res.data.success);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(streamStopError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const liveFeedStreamStop = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(streamStopInProgress());

    const URL = urlstreamStopLiveFeed(url, id);
    Axios.post(URL, {}, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(streamStopSuccess(res.data && res.data.success));
            if (cb) {
                cb(res.data && res.data.success);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(streamStopError(message));
            if (cb) {
                cb(null);
            }
        });
};

const updateLiveStreamDestinationInProgress = () => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_IN_PROGRESS,
    };
};

const updateLiveStreamDestinationSuccess = (value) => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_SUCCESS,
        value,
    };
};

const updateLiveStreamDestinationError = (message) => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_ERROR,
        message,
        variant: 'error',
    };
};

export const updateLiveStreamDestination = (url, id, nodeID, data, cb) => (dispatch) => {
    dispatch(updateLiveStreamDestinationInProgress());

    const URL = urlupdateLiveStreamDestination(url, id);
    Axios.put(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(updateLiveStreamDestinationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateLiveStreamDestinationError(message));
            if (cb) {
                cb(null);
            }
        });
};

const updateLSDestinationInProgress = () => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_IN_PROGRESS,
    };
};

const updateLSDestinationSuccess = (value) => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_SUCCESS,
        value,
    };
};

const updateLSDestinationError = (message) => {
    return {
        type: LIVE_STREAM_DESTINATION_UPDATE_ERROR,
        message,
        variant: 'error',
    };
};

export const updateLSDestination = (url, nodeID, id, destinationID, data, cb) => (dispatch) => {
    dispatch(updateLSDestinationInProgress());

    const URL = urlUpdateLSDestination(url, id, destinationID);
    Axios.put(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(updateLSDestinationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateLSDestinationError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setStreamText = (value, valid) => {
    return {
        type: LIVE_STREAM_TEXT_SET,
        value,
        valid,
    };
};

export const setStreamTextEnable = (value) => {
    return {
        type: LIVE_STREAM_TEXT_ENABLE_SET,
        value,
    };
};

const addStreamTextInProgress = () => {
    return {
        type: LIVE_STREAM_TEXT_ADD_IN_PROGRESS,
    };
};

const addStreamTextSuccess = (value) => {
    return {
        type: LIVE_STREAM_TEXT_ADD_SUCCESS,
        value,
    };
};

const addStreamTextError = (message) => {
    return {
        type: LIVE_STREAM_TEXT_ADD_ERROR,
        message,
        variant: 'error',
    };
};

export const addStreamText = (url, id, nodeID, data, cb) => (dispatch) => {
    dispatch(addStreamTextInProgress());

    const URL = urladdStreamText(url, id);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(addStreamTextSuccess(res.data && res.data.success));
            if (cb) {
                cb(res.data && res.data.success);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addStreamTextError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setStreamDefaultFile = (value) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_SET,
        value,
    };
};

const addStreamDefaultFileInProgress = () => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_ADD_IN_PROGRESS,
    };
};

const addStreamDefaultFileSuccess = (value) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_ADD_SUCCESS,
        value,
    };
};

const addStreamDefaultFileError = (message) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_ADD_ERROR,
        message,
        variant: 'error',
    };
};

const setUploadProgress = (value, ID) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_ADD_PROGRESS_SET,
        value,
    };
};

export const uploadAssetCancel = (cancel, ID) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_ADD_CANCEL_SET,
        cancel,
    };
};

export const addStreamDefaultFile = (url, userId, nodeID, file, cb) => (dispatch) => {
    dispatch(addStreamDefaultFileInProgress());

    const CancelToken = Axios.CancelToken;
    const formData = new FormData();
    formData.append('_type', getAssetType(file.type));
    formData.append('file', file);

    const URL = urladdStreamDefaultFile(url, userId);
    Axios.post(URL, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
        onUploadProgress: (progressEvent) => {
            dispatch(setUploadProgress(progressEvent));
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(uploadAssetCancel(cancel));
        }),
    })
        .then((res) => {
            dispatch(addStreamDefaultFileSuccess(res.data && res.data.asset));
            cb(null, res.data && res.data.asset);
        })
        .catch((error) => {
            const message = handleErrorMessage(error, 'Canceled File Upload!');
            dispatch(addStreamDefaultFileError(message));
            cb(error, null);
        });
};

const fetchLiveStreamDefaultFileInProgress = () => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_FETCH_IN_PROGRESS,
    };
};

const fetchLiveStreamDefaultFileSuccess = (value) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_FETCH_SUCCESS,
        value,
    };
};

const fetchLiveStreamDefaultFileError = (message) => {
    return {
        type: LIVE_STREAM_DEFAULT_FILE_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchLiveStreamDefaultFile = (url, userId, nodeID) => (dispatch) => {
    dispatch(fetchLiveStreamDefaultFileInProgress());

    const URL = urlgetStreamDefaultFile(url, userId);
    Axios.get(URL, {
        responseType: 'blob',
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            const profileImage = res.data;
            const file = new Blob([profileImage], { type: profileImage.type });
            const fileUrl = URL.createObjectURL(file);

            dispatch(fetchLiveStreamDefaultFileSuccess(fileUrl));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLiveStreamDefaultFileError(message));
        });
};

// UPDATE, delete destination
const fetchLSDestinationInProgress = () => {
    return {
        type: FETCH_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    };
};

const fetchLSDestinationSuccess = (value) => {
    return {
        type: FETCH_LIVE_STREAM_DESTINATION_SUCCESS,
        value,
    };
};

const fetchLSDestinationError = (message) => {
    return {
        type: FETCH_LIVE_STREAM_DESTINATION_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchLSDestination = (apiUrl, nodeID, liveStreamID, destinationID, cb) => (dispatch) => {
    dispatch(fetchLSDestinationInProgress());

    const URL = urlUpdateLSDestination(apiUrl, liveStreamID, destinationID);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchLSDestinationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchLSDestinationError(message));
            if (cb) {
                cb(null);
            }
        });
};

const addLSDestinationInProgress = () => {
    return {
        type: ADD_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    };
};

const addLSDestinationSuccess = (value) => {
    return {
        type: ADD_LIVE_STREAM_DESTINATION_SUCCESS,
        value,
    };
};

const addLSDestinationError = (message) => {
    return {
        type: ADD_LIVE_STREAM_DESTINATION_ERROR,
        message,
        variant: 'error',
    };
};

export const addLSDestination = (apiUrl, nodeID, liveStreamID, data, cb) => (dispatch) => {
    dispatch(addLSDestinationInProgress());

    const URL = urlAddLSDestination(apiUrl, liveStreamID);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(addLSDestinationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addLSDestinationError(message));
            if (cb) {
                cb(null);
            }
        });
};

const deleteLSDestinationInProgress = () => {
    return {
        type: DELETE_LIVE_STREAM_DESTINATION_IN_PROGRESS,
    };
};

const deleteLSDestinationSuccess = (message) => {
    return {
        type: DELETE_LIVE_STREAM_DESTINATION_SUCCESS,
        message,
        variant: 'success',
    };
};

const deleteLSDestinationError = (message) => {
    return {
        type: DELETE_LIVE_STREAM_DESTINATION_ERROR,
        message,
        variant: 'error',
    };
};

export const deleteLSDestination = (apiUrl, nodeID, liveStreamID, destinationID, cb) => (dispatch) => {
    dispatch(deleteLSDestinationInProgress());

    const url = urlUpdateLSDestination(apiUrl, liveStreamID, destinationID);
    Axios.delete(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(deleteLSDestinationSuccess('Destination Deleted Successfully'));
            if (cb) {
                cb(null);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(deleteLSDestinationError(message));
            if (cb) {
                cb(error);
            }
        });
};

const updateStreamDetailsInProgress = () => {
    return {
        type: UPDATE_STREAM_DETAILS_IN_PROGRESS,
    };
};

const updateStreamDetailsSuccess = (value, message, id) => {
    return {
        type: UPDATE_STREAM_DETAILS_SUCCESS,
        value,
        message,
        id,
    };
};

const updateStreamDetailsError = (message) => {
    return {
        type: UPDATE_STREAM_DETAILS_ERROR,
        message,
    };
};

export const updateStreamDetails = (data, id, cb) => (dispatch) => {
    dispatch(updateStreamDetailsInProgress());

    const url = urlUpdateLiveStreamMetaData(id);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(updateStreamDetailsSuccess(res.data && res.data.result, 'Media Node Added Successfully', id));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(updateStreamDetailsError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

const fetchCombinedChannelsInProgress = () => {
    return {
        type: FETCH_COMBINED_CHANNELS_IN_PROGRESS,
    };
};

const fetchCombinedChannelsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_COMBINED_CHANNELS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchCombinedChannelsError = (message) => {
    return {
        type: FETCH_COMBINED_CHANNELS_ERROR,
        message,
    };
};

export const fetchCombinedChannels = (contractAddress, address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchCombinedChannelsInProgress());

    const url = urlFetchCombinedChannels(contractAddress, address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchCombinedChannelsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchCombinedChannelsError(message));
            if (cb) {
                cb(null);
            }
        });
};

const streamPathInProgress = () => {
    return {
        type: STREAM_PATH_IN_PROGRESS,
    };
};

const streamPathSuccess = (value) => {
    return {
        type: STREAM_PATH_SUCCESS,
        value,
    };
};

const streamPathError = (message) => {
    return {
        type: STREAM_PATH_ERROR,
        message,
        variant: 'error',
    };
};

export const streamPath = (url, id, nodeID, cb) => (dispatch) => {
    dispatch(streamPathInProgress());

    const URL = urlstreamPath(url, id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(streamPathSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(streamPathError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchMediaNodeLiveStreamsInProgress = () => {
    return {
        type: MEDIA_NODE_LIVE_STREAMS_FETCH_IN_PROGRESS,
    };
};

const fetchMediaNodeLiveStreamsSuccess = (value) => {
    return {
        type: MEDIA_NODE_LIVE_STREAMS_FETCH_SUCCESS,
        value,
    };
};

const fetchMediaNodeLiveStreamsError = (message) => {
    return {
        type: MEDIA_NODE_LIVE_STREAMS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchMediaNodeLiveStreams = (url, nodeID, cb) => (dispatch) => {
    dispatch(fetchMediaNodeLiveStreamsInProgress());

    const URL = urlFetchMediaNodeLiveStreams(url);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(fetchMediaNodeLiveStreamsSuccess(res.data && res.data.result && res.data.result.list));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchMediaNodeLiveStreamsError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

export const showMediaNodeSelectionDialog = (value, data) => {
    return {
        type: MEDIA_NODE_SELECTION_DIALOG_SHOW,
        value,
        data,
    };
};

export const hideMediaNodeSelectionDialog = () => {
    return {
        type: MEDIA_NODE_SELECTION_DIALOG_HIDE,
    };
};

const connectLiveStreamToMediaNodeInProgress = () => {
    return {
        type: CONNECT_LIVE_STREAM_TO_MEDIA_NODE_IN_PROGRESS,
    };
};

const connectLiveStreamToMediaNodeSuccess = (value) => {
    return {
        type: CONNECT_LIVE_STREAM_TO_MEDIA_NODE_SUCCESS,
        value,
    };
};

const connectLiveStreamToMediaNodeError = (message) => {
    return {
        type: CONNECT_LIVE_STREAM_TO_MEDIA_NODE_ERROR,
        message,
        variant: 'error',
    };
};

export const connectLiveStreamToMediaNode = (url, liveStreamID, data, nodeID, cb) => (dispatch) => {
    dispatch(connectLiveStreamToMediaNodeInProgress());

    const URL = urlConnectLiveStreamToMediaNode(url, liveStreamID);
    Axios.put(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem(`acToken_of_studio_media_node_${nodeID}`),
        },
    })
        .then((res) => {
            dispatch(connectLiveStreamToMediaNodeSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(connectLiveStreamToMediaNodeError(message));
            if (cb) {
                cb(null);
            }
        });
};

const checkBroadcastStreamEligibilityInProgress = () => {
    return {
        type: BROADCAST_STREAM_ELIGIBILITY_CHECK_IN_PROGRESS,
    };
};

const checkBroadcastStreamEligibilitySuccess = (channels, eligible) => {
    return {
        type: BROADCAST_STREAM_ELIGIBILITY_CHECK_SUCCESS,
        channels,
        eligible,
    };
};

const checkBroadcastStreamEligibilityError = (message) => {
    return {
        type: BROADCAST_STREAM_ELIGIBILITY_CHECK_ERROR,
        message,
        variant: 'error',
    };
};

export const checkBroadcastStreamEligibility = (cb) => (dispatch) => {
    dispatch(checkBroadcastStreamEligibilityInProgress());

    const URL = urlCheckBroadcastStreamEligibility();
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(checkBroadcastStreamEligibilitySuccess(res.data && res.data.result && res.data.result.channels, res.data && res.data.result && res.data.result.is_eligible));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.channels, res.data && res.data.result && res.data.result.is_eligible);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(checkBroadcastStreamEligibilityError(message));
            if (cb) {
                cb(null, message);
            }
        });
};
